const locale = {
  'demandList.btn.totalMessage': '合计: {skuTotal} 个SKU, 共 {productTotal} 件商品',
  'demandList.btn.deleteProduct': '删除商品',
  'demandList.btn.clearQuantity': '清空数量',
  'demandList.btn.exportSelectedProducts': '导出选中商品',
  'demandList.btn.moveToOtherLists': '移动至其他清单',

  'demandList.message.deleting': '删除中...',
  'demandList.message.deleteSuccessfully': '删除成功',
  'demandList.message.deleteFailed': '删除失败',

  'demandList.message.clearing': '清空中...',
  'demandList.message.clearQuantitySuccessfully': '清空数量成功',
  'demandList.message.clearQuantityFailed': '删除数量失败',

  'demandList.message.exporting': '导出中...',
  'demandList.message.exportFailed': '导出失败',

  'demandList.exported.message': '选中商品已导出',
  'demandList.exported.description': '可在浏览器的下载文件中查看',

  'demandList.title': '< 需求清单',
  'demandList.inquiry.noproduct': '请选择商品',
  'demandList.inquiry.productAllZero': '请输入商品数量',
  'demandList.inquiry.prompt.title': '提示',
  'demandList.inquiry.quantityprompt.title': '提示',
  'demandList.inquiry.quantityprompt.content': '部分商品需求数量为0，继续询价需求数量为0的商品将不会被提交',
  'demandList.inquiry.quantityprompt.ok': '继续询价',
  'demandList.inquiry.quantityprompt.cancel': '去完善',
  'demandList.inquiry.success': '询价成功',
  'demandList.inquiry.check.content':
    '确认后我们将尽快确认您的询价需求，处理进度将以邮件、WhatsApp或电话的方式告知',
  'demandList.inquiry.check.clear.content': '删除本次提交的商品',
  'demandList.inquiry.check.notclear.content': '不删除本次提交的商品',
  'demandList.inquiry.textarea.placeholder': '如未找到你要的配件或对品质交期等特殊要求均可在此注明',
  'demandList.inquiry.attachment.filetypeerror': '文件格式不正确',
  'demandList.inquiry.attachment.filesizeerror': '文件大小超过限制',
  'demandList.inquiry.attachment.btn': '上传附件',
  'demandList.inquiry.attachment.accepttext':
    '支持.pdf、.xlsx、.doc、.png、.jpg，最多上传5个文件，单个文件不超过10M',
  'demandList.inquiry.btn': '去询价',
  'demandList.move.title': '移动至其他清单',
  'demandList.move.content':
    '保存后将移动当前选中商品至目标需求清单中，如不存在你可自行创建，最多可创建7条',
  'demandList.move.input.placeholder': '创建需求清单，回车保存',
  'demandList.move.unsave': '（未保存）',
  'demandList.move.select.maxlength': '最多创建7条',
  'demandList.move.success': '移动成功',
  'demandList.versions.current': '当前',
  'demandList.versions.deleteprompt.title': '确认删除',
  'demandList.versions.deleteprompt.content': '需求清单删除后将无法恢复，确认删除？',
  'demandList.versions.edit.title': '编辑',
  'demandList.versions.input.placeholder': '请输入',

  'demandList.modal.okText': '确认',
  'demandList.modal.cancelText': '取消',

  'demandList.modal.title.delete': '确认删除商品?',
  'demandList.modal.content.delete': '确认后将删除已选中的商品',
  'demandList.modal.title.clear': '确认清空数量?',
  'demandList.modal.content.clear': '确认后将已选中商品填写数量重置为0',
};

export default locale;
